import { client } from "@/lib/api";
import type { Repo } from "@rivets/core";

/**
 * A repository's square identity tile: its uploaded icon, or a neutral chip
 * carrying the initial.
 *
 * The tile used to hash the repository id into one of ten saturated hues, which
 * put a random colour on every row of a list whose whole job is to be quiet —
 * and the hue carried no meaning, so the reader learned nothing from it. A
 * repository that wants to be recognised uploads an icon; everything else gets
 * the same `--surface-3` chip the rest of the app uses for a neutral token.
 */
export function RepoIdentity({ repo, size = 16 }: { repo: Repo; size?: number }) {
  const fallback = repo.name.trim().charAt(0).toUpperCase() || "R";
  return (
    <span
      className="sidebar-repo-identity"
      /* The glyph scales with the tile so an 18px header chip and a 14px row
         chip read as the same object at two sizes. */
      style={{ width: size, height: size, fontSize: Math.round(size * 5.3) / 10 }}
    >
      {repo.icon ? <img src={client.repoIconUrl(repo.orgId, repo.icon.id)} alt="" decoding="async" /> : fallback}
    </span>
  );
}
